import { isDayjs } from 'dayjs';

const dayjs = require('dayjs');
const sv = require('dayjs/locale/sv');

const LocalizedFormat = require('dayjs/plugin/localizedFormat');

dayjs.extend(LocalizedFormat);

export const getVerboseFormatedDate = (dateString: string): string =>
  dayjs(dateString).locale('sv').format('LLL');

export const getLongFormatedDate = (dateString: string): string =>
  dayjs(dateString).locale('sv').format('ll');

export const getFormatedDateSmallScreen = (dateString: string): string =>
  dayjs(dateString).locale('sv').format('D/M-YY');

export const getFormatedDate = (dateString: string): string =>
  dayjs(dateString).locale('sv').format('L');

export const getDateAndTime = (dateString: string, format?: string): string =>
  dayjs(dateString)
    .locale('sv')
    .format(format ? format : 'ddd MMM DD HH:MM');
